(() => {
  if (customElements.get('famli-carousel')) return;
  class FamliCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.famli-carousel__track');
      const slides = [...this.querySelectorAll('.famli-carousel__slide')];
      const previousButtons = [...this.querySelectorAll('[data-carousel-prev]')];
      const nextButtons = [...this.querySelectorAll('[data-carousel-next]')];
      const dots = [...this.querySelectorAll('[data-carousel-dot]')];
      const cue = this.querySelector('[data-carousel-cue]');
      const cueSymbol = this.querySelector('.famli-carousel__swipe-symbol');
      const current = this.querySelector('[data-carousel-current]');
      const activeIndex = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      const update = () => {
        const index = activeIndex();
        current.textContent = String(index + 1);
        previousButtons.forEach(button => { button.disabled = index === 0; });
        nextButtons.forEach(button => { button.disabled = index === slides.length - 1; });
        dots.forEach((dot, position) => {
          const selected = position === index;
          dot.classList.toggle('is-active', selected);
          if (selected) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (cue) cue.textContent = index === slides.length - 1 ? 'Swipe tilbage' : 'Swipe for flere videoer';
        if (cueSymbol) cueSymbol.textContent = index === slides.length - 1 ? '←' : '→';
        slides.forEach((slide, i) => {
          slide.inert = i !== index;
          if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
        });
      };
      const goTo = index => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: target * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      const go = delta => goTo(activeIndex() + delta);
      previousButtons.forEach(button => button.addEventListener('click', () => go(-1), options));
      nextButtons.forEach(button => button.addEventListener('click', () => go(1), options));
      dots.forEach(button => button.addEventListener('click', () => goTo(Number(button.dataset.carouselDot)), options));
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  }
  customElements.define('famli-carousel', FamliCarousel);
})();
